@if (dataSource) {
  <icz-circulation-table
    tableId="document-detail-activities"
    tableTitle="Úkony"
    [dataSource]="dataSource"
    [viewType]="CirculationView.DOCUMENT_ACTIVITIES"
  >

    <icz-label noDataLabel label="Žádné úkony"></icz-label>

  </icz-circulation-table>
}
